<template>
  <div class="system-settings-main">
    <!-- メインメニュー表示 -->
    <SystemSettingsView
      v-if="currentPage === null"
      :active-tab="activeTab"
      @tab-changed="handleTabChange"
      @navigate-to-setting="handleNavigateToSetting"
    />

    <!-- 自治体組織設定画面 -->
    <MunicipalOrganizationContainer
      v-else-if="currentPage === 'municipal-organization'"
      @back-to-menu="handleBackToMenu"
    />

    <!-- 収集企業設定画面 -->
    <CollectionCompanyContainer
      v-else-if="currentPage === 'collection-company'"
      @back-to-menu="handleBackToMenu"
    />

    <!-- 収集地区設定画面 -->
    <CollectionDistrictContainer
      v-else-if="currentPage === 'collection-district'"
      @back-to-menu="handleBackToMenu"
    />

    <!-- 地区町名設定画面 -->
    <DistrictTownContainer
      v-else-if="currentPage === 'district-town'"
      @back-to-menu="handleBackToMenu"
    />

    <!-- ごみ・かご種別設定画面 -->
    <WasteTypeContainer
      v-else-if="currentPage === 'waste-type'"
      @back-to-menu="handleBackToMenu"
    />

    <!-- 収集カレンダー設定画面 -->
    <CollectionCalendarContainer
      v-else-if="currentPage === 'collection-calendar'"
      @back-to-menu="handleBackToMenu"
    />

    <!-- 他の設定画面は今後追加予定 -->
    <div v-else class="error-page">
      <h4>ページが見つかりません</h4>
      <p>指定された設定ページは存在しません。</p>
      <BButton @click="handleBackToMenu" variant="primary">
        メニューに戻る
      </BButton>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { BButton } from 'bootstrap-vue-next'
import SystemSettingsView from '../components/common/SystemSettingsView.vue'
import MunicipalOrganizationContainer from './MunicipalOrganizationContainer.vue'
import CollectionCompanyContainer from './CollectionCompanyContainer.vue'
import CollectionDistrictContainer from './CollectionDistrictContainer.vue'
import DistrictTownContainer from './DistrictTownContainer.vue'
import WasteTypeContainer from './WasteTypeContainer.vue'
import CollectionCalendarContainer from './CollectionCalendarContainer.vue'

const route = useRoute()
const router = useRouter()

const activeTab = ref('collection')

const currentPage = computed(() => {
  return route.params.page || null
})

const handleTabChange = (tabKey) => {
  activeTab.value = tabKey
}

const handleNavigateToSetting = (routeParam) => {
  router.push(`/system-settings/${routeParam}`)
}

const handleBackToMenu = () => {
  router.push('/system-settings')
}

onMounted(() => {
  if (route.query.tab) {
    activeTab.value = route.query.tab
  }
})
</script>

